import Box from '@mui/material/Box';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import MenuItem from '@mui/material/MenuItem';
import Select, { type SelectChangeEvent } from '@mui/material/Select';
import Typography from '@mui/material/Typography';

import { PAGE_SIZE_OPTIONS } from 'src/models/recipe/list/pagination-config';

// ----------------------------------------------------------------------

type Props = {
  page: number;
  onPage: (page: number) => void;
  pageSize: number;
  onPageSize: (pageSize: number) => void;
  pageCount: number;
};

export default function RecipePagination({ page, onPage, pageSize, onPageSize, pageCount}: Props) {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      alignItems="center"
      justifyContent={{ xs: 'center', sm: 'space-between' }}
      spacing={{ xs: 2, sm: 0 }}
      sx={{ mt: 4 }}
    >
      <Box sx={{ width: 150, display: { xs: 'none', sm: 'block' } }} />

      <Pagination
        color="primary"
        variant="soft"
        shape="rounded"
        siblingCount={0}
        boundaryCount={1}
        showFirstButton
        showLastButton
        page={page}
        count={pageCount}
        onChange={(_event, value) => onPage(value)}
        sx={{
          '& .MuiPagination-ul': {
            flexWrap: 'nowrap',
          },
          '& .MuiPaginationItem-root': {
            minWidth: { xs: 40, sm: 36, md: 40 },
            height: { xs: 40, sm: 36, md: 40 },
            fontSize: { xs: '1rem', sm: '0.875rem', md: '1rem' },
          },
          '& .MuiPaginationItem-firstLast': {
            display: { xs: 'none', sm: 'inline-flex' },
          },
        }}
      />

      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography variant="body2" color="text.secondary">
          Na stronie:
        </Typography>
        <Select
          size="small"
          value={pageSize}
          onChange={(e: SelectChangeEvent<number>) => onPageSize(Number(e.target.value))}
        >
          {PAGE_SIZE_OPTIONS.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </Stack>
    </Stack>
  );
}
